import { useEffect, useState } from 'react';
import { CardToken } from '../../Components/CardToken';
import { Api } from '../../services/api';

export const Token2 = () => {
  const [tokens, setTokens] = useState(null);

  const findAllTokens = async () => {
    try {
      const tokens = await Api.get('/token');
      console.log(tokens);
      setTokens(tokens.data);
    } catch (e) {
      setTokens(null);
    }
  };

  useEffect(() => {
    findAllTokens();
  }, []);

  return (
    <div className="mt-4 container">
      <div className="row mt-4">
        <h1></h1>
        {tokens ? (
          tokens.map((token) => (
            <div key={token.id} className="col-xxl-4 col-lg-6 col-md-12">
              <CardToken
                data={{
                  nTransportadora: token.id,
                  motorista: token.motorista,
                }}
              />
            </div>
          ))
        ) : (
          <td>Não foi encontrado nenhum token</td>
        )}
      </div>
    </div>
  );
};
